import { AdminOrganizationsListResponseDto, AdminService } from 'app/API';
import type { TCall } from 'app/queries/types/TCall';

export const fetchAllOrganizationsForExport = async (
  call: TCall,
  search: string,
  includeExternallyManaged: boolean,
): Promise<AdminOrganizationsListResponseDto> => {
  const baseExportParams = {
    pageNo: '1',
    orderBy: 'createdAt',
    orderType: 'desc',
    search,
    includeExternallyManaged,
  };
  const countResponse = await call(() =>
    AdminService.getOrganizationsList({
      ...baseExportParams,
      pageSize: '1',
    }),
  );

  if (countResponse.count === 0) {
    return { count: 0, data: [], featureFlags: {} };
  }

  return call(() =>
    AdminService.getOrganizationsList({
      ...baseExportParams,
      pageSize: countResponse.count.toString(),
    }),
  );
};
